import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import PasswordChangeForm from "@/modules/Gdv/components/PasswordChangeForm.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useRouter} from "vue-router";
import apiGdv from "@/modules/Gdv/api";
import {onMounted, reactive, ref} from "vue";
import {useGdvStore} from "@/modules/Gdv/store";
import GdvAccess from "@/shared/model/GdvAccess";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {useNavigationStore} from "@/modules/Navigation/store";
import copyTo from "@/shared/utils/CopyTo";
import notificationService from "@/shared/services/NotificationService";


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordChangePage',
  setup(__props) {

const _router = useRouter();
const _form = ref<InstanceType<typeof PasswordChangeForm> | null>()
const _gdvStore = useGdvStore();
const _gdvAccess = reactive<GdvAccess>(new GdvAccess())
const _spinner = useSpinner();
const _navigationStore = useNavigationStore();

async function p_init() {
  if (!_navigationStore.currentGdvAccessId || !_gdvStore.gdvAccess || _navigationStore.currentGdvAccessId !== _gdvStore.gdvAccess.id) {
    _router.back()
    return;
  }
  try {
    _spinner.show()
    {
//      copyTo(_clipboardStore.gdvaccess, _gdvAccess.value)
      copyTo(_gdvStore.gdvAccess, _gdvAccess)
    }
  } finally {
    _spinner.hide()
  }
}


//_gdvAccess.value  _clipboardStore.gdvaccess;
onMounted(async () => {

  await p_init()
  //console.log(_gdvAccess)

})

function OnCancel() {
  return _router.back();
}

async function onSave() {
  if (_form.value && _form.value.validate()) {
    const result = _form.value.getPassword();
    const res = await apiGdv.changePassword(_gdvAccess.id, result)
    if (res) {
      notificationService.success(res)
      _router.back()
    }
    return
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Passwort Änderung" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(PasswordChangeForm, {
                ref_key: "_form",
                ref: _form,
                data: _gdvAccess
              }, null, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Save,
                onClick: onSave
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Speichern ", -1)
                ]))]),
                _: 1
              }, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Cancel,
                onClick: OnCancel
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Abbrechen ", -1)
                ]))]),
                _: 1
              }, 8, ["kind"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})